// @ts-nocheck
import React from 'react';
import BrandRow from './BrandRow/BrandRow';
import { Naskor } from '../../../../../js/components/naskor';
import ProductLabelService from './ProductLableService/ProductLabelService';
import * as InterfaceCollection from '../InterfaceCollection';
import { formatCurrencyEur } from '../../../../Helper/formatter';

export default function Table({ basket, reloadBasket }: {
  basket: InterfaceCollection.VtsBasket;
  reloadBasket: CallableFunction;
}) {
  return (
    <div>
        <table className="basket-table">
          <thead>
            <tr>
              <th className="basket-table__brand">Brand</th>
              <th> </th>
              <th className="basket-table__quantity">Quantity</th>
              <th className="basket-table__total">Total</th>
            </tr>
          </thead>
          <tbody>
            {basket.brand_positions.map((brandPosition) => {
              return (
                <BrandRow
                  basket={basket}
                  key={brandPosition.brand.id}
                  brandPosition={brandPosition}
                />
              );
            })}
          </tbody>
          <tfoot style={{ borderBottom: 'none' }}>
            <tr>
              <td className="basket-table__footertext" colSpan={2}>
                Total Order
              </td>
                <td className="basket-table__unitcount">
                {basket.total_quantity}
              </td>
              <td className="basket-table__totalprice">
                {formatCurrencyEur(
                  basket.total_position_price_excl_vat
                )}
              </td>
            </tr>
          </tfoot>
        </table>
        <table className="basket-footer">
          <tbody>
            <tr>
              <td>
                <strong>
                  <span
                    data-toggle="tooltip"
                    data-placement="top"
                    title="Attach product label with the nutrition facts in the language of my country to the products (if available)"
                  >
                    Product Label Service
                  </span>
                </strong>
              </td>
              <td>
                <ProductLabelService
                  basket={basket}
                  reloadBasket={reloadBasket}
                />
              </td>
              <td> </td>
              <td>
                <table className="order-total-table">
                  <tbody>
                    <tr></tr>
                {basket.position_vat_info === false ? (
                      <tr>
                        <td>
                          Product VAT
                          <span className={'basket-spinner'} />
                        </td>
                        <td className="text-right">
                          <strong>
                            <span className={'basket-spinner'} />
                          </strong>
                        </td>
                      </tr>
                      ) : (
                      basket.position_vat_info.length > 0 &&
                      basket.position_vat_info.map((vatInfo) => {
                        return (
                          <tr key={vatInfo.vatRate}>
                            <td>
                              Product VAT ({vatInfo.vatRate}% of{' '}
                              {formatCurrencyEur(vatInfo.vatFrom)})
                            </td>
                            <td className="text-right">
                              <strong>
                                {formatCurrencyEur(vatInfo.vatValue)}
                              </strong>
                            </td>
                          </tr>
                        );
                      })
                    )}
                  </tbody>
                </table>
                <table className="order-total-table">
                  <tbody>
                    <tr>
                      <td>Shipping Costs</td>
                      <td className="text-right">
                        <strong>calculated after checkout</strong>
                      </td>
                    </tr>
                  </tbody>
                </table>
                        {basket.is_product_label_service && (
                  <table className="order-total-table">
                    <tbody>
                      <tr>
                        <td>Product Label Service</td>
                        <td className="text-right">
                          <strong>
                            {formatCurrencyEur(
                              basket.total_position_label_price_excl_vat ?? 0
                            )}
                          </strong>
                          <br />
                        </td>
                      </tr>
                      {basket.product_label_service_vat_info ===
                      false ? (
                        <tr>
                          <td>
                            Product Label Service VAT
                            <span className={'basket-spinner'} />
                          </td>
                          <td className="text-right">
                            <strong>
                              <span className={'basket-spinner'} />
                            </strong>
                          </td>
                        </tr>
                        ) : (
                        basket.product_label_service_vat_info
                          .length > 0 &&
                        basket.product_label_service_vat_info.map(
                          (vatInfo) => {
                            return (
                              <tr key={vatInfo.vatRate}>
                                <td>
                                  Product Label Service VAT ({vatInfo.vatRate}%
                                  of {formatCurrencyEur(vatInfo.vatFrom)})
                                </td>
                                <td className="text-right">
                                  <strong>
                                    {formatCurrencyEur(vatInfo.vatValue)}
                                  </strong>
                                </td>
                              </tr>
                            );
                          }
                        )
                      )}
                    </tbody>
                  </table>
                )}
                <table className="order-total-table">
                  <tbody>
                    <tr>
                      <td>
                        <strong>Order Total</strong>
                      </td>
                      <td className="text-right">
                        <strong>
                          <u>
                              {basket.total_price_incl_vat ===
                            false ? (
                              <span className={'basket-spinner'} />
                            ) : (
                            formatCurrencyEur(
                                basket.total_price_incl_vat ?? 0
                              )
                            )}
                          </u>
                        </strong>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <table className="order-total-table">
                  <tbody>
                    <tr className="small">
                      <td>Order Weight</td>
                      <td className="text-right">
                        {Naskor.formatWeight(
                          basket.total_weight_in_gram
                        )}
                        <br />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
  );
}
